var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.component},[_c('show-cards',{attrs:{"title":"Saved Movies","shows":_vm.shows}}),(_vm.shows !== null && _vm.shows.length === 0)?_c('h3',[_vm._v(" No Movies Saved ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }